import Swiper from 'swiper';
import { Autoplay, EffectFade, EffectCube, EffectFlip, EffectCards, EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import Parvus from 'parvus'

const $ = jQuery;

sliderBlock($);

function sliderBlock($) {
  $('.sliderBlock').each(function (index) {
    const $this = $(this);
    const sliderId = $this.attr('data-slides-id');
    const effect = $this.attr('data-slides-fade');

    $this.find('.wp-block-cover').addClass('swiper-slide');

    const sliderClass = `sliderBlock_${index + 1}`;
    $this.addClass(sliderClass);

    // Find navigation elements (they might be in parent container)
    const $container = $this.closest('.wp-block-tema99-slider');
    const $prevBtn = $container.length > 0 ? $container.find('.swiper-button-prev') : $this.find('.swiper-button-prev');
    const $nextBtn = $container.length > 0 ? $container.find('.swiper-button-next') : $this.find('.swiper-button-next');


    // Custom Navigation SVG 
    if ($this.attr('data-custom-navigation') === 'true') {
      const leftArrowSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="43.525" height="35.559" viewBox="0 0 43.525 35.559"><path id="Tracciato_10615" data-name="Tracciato 10615" d="M17.78,0,0,17.779,17.78,35.558l3.058-2.987L8.179,19.913H43.525V15.645H8.179L20.838,2.987Z" transform="translate(0 0)"/></svg>';
      const rightArrowSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="43.525" height="35.559" viewBox="0 0 43.525 35.559"><path id="Tracciato_10616" data-name="Tracciato 10616" d="M17.78,0,0,17.779,17.78,35.559l3.058-2.987L8.179,19.914H43.525V15.646H8.179L20.838,2.987Z" transform="translate(43.525 35.559) rotate(180)"/></svg>';

      $prevBtn.html(leftArrowSVG);
      $nextBtn.html(rightArrowSVG);
    }

    // Opzioni slider 
    let swiperOptions = {
      modules: [Autoplay, EffectFade, EffectCube, EffectFlip, EffectCards, EffectCoverflow, Navigation, Pagination],
      slidesPerView: parseInt($this.attr('data-slides-number')),
      spaceBetween: parseInt($this.attr('data-slides-spazio')),
      speed: parseInt($this.attr('data-slides-velocity')),
      loop: $this.attr('data-slides-loop') === 'true',
      rewind: $this.attr('data-slides-rewind') === 'true',
      navigation: $this.attr('data-slides-freccie') === 'true' && $nextBtn.length > 0 && $prevBtn.length > 0 ? {
        nextEl: $nextBtn[0],
        prevEl: $prevBtn[0],
      } : false,
      pagination: $this.attr('data-slides-paginazione') === 'true' ? {
        el: `.${sliderClass} .swiper-pagination`,
        clickable: true,
      } : false,
      toolbar: $this.attr('data-slides-toolbar') === 'true' ? {
        el: `.${sliderClass} .swiper-toolbar`,
        draggable: true,
      } : false,
      breakpoints: {
        0: {
          spaceBetween: 5,
        },
        768: {
          spaceBetween: parseInt($this.attr('data-slides-spazio')),
        },
      },

    };

    // Add effect only if it's not false or slide
    if (effect && effect !== 'false') {
      swiperOptions.effect = effect;
    }

    // Configure autoplay if enabled
    if ($this.attr('data-slides-autoplay') === 'true') {
      swiperOptions.autoplay = {
        delay: parseInt($this.attr('data-slides-time')),
        disableOnInteraction: $this.attr('data-slides-interaction') === 'true',
        pauseOnMouseEnter: $this.attr('data-slides-hover') === 'true',
      };
    }


    const customRules = $this.attr('data-extra-rules');
    if (customRules) {
      try {
        let formattedCustomRules = customRules
          .replace(/([a-zA-Z0-9_]+)\s*:/g, '"$1":')  // Aggiunge virgolette alle chiavi
          .replace(/,\s*}/g, '}') // Rimuove le virgole prima delle parentesi chiuse "}"
          .replace(/,\s*$/, '');  // Rimuove l'ultima virgola se presente

        const parsedCustomRules = JSON.parse(`{${formattedCustomRules}}`);

        if (parsedCustomRules.breakpoints && swiperOptions.breakpoints) {
          parsedCustomRules.breakpoints = {
            ...swiperOptions.breakpoints,
            ...parsedCustomRules.breakpoints,
            0: {
              ...parsedCustomRules.breakpoints[0],
              spaceBetween: 10,
            }
          };
        }

        swiperOptions = { ...swiperOptions, ...parsedCustomRules };
      } catch (error) {
        console.error('Error parsing custom rules:', error);
      }
    }

    /**
     * Hook globale permette di gestire opzioni slider in secondo momento.
     *   
     * Esempio:
     * window.beforeSwiperInit = function(swiperOptions, $element, sliderId) {
     * if (sliderId === 'ANCORA') {swiperOptions.autoplay = {delay: 5000,};};
     * };
     * 
     */

    if (typeof window.beforeSwiperInit === 'function') {
      window.beforeSwiperInit(swiperOptions, $this, sliderId);
    }

    // INIT - Use direct element reference instead of selector
    const swiper = new Swiper($this[0], swiperOptions);

    // Parvus Lightbox
    if ($this.attr('data-slides-lightbox') === 'true') {
      $this.find('.wp-block-cover:not(.swiper-slide-duplicate)').each(function () {
        const $cover = $(this);
        const urlImg = $cover.find('.wp-block-cover__image-background').attr('src');
        $cover.prepend(`<a href="${urlImg}" class="lightbox sliderBlock_lightbox_link" data-group="gallery_${index + 1}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index:2"></a>`);
      });

      new Parvus();
    }
  });
}
